export default __webpack_public_path__ + "static/lifeprint-demo-2-219c2773fa9988a502dc924d02c5724d.webp";